import { Box, Button, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import useCommonMediaQuery from '../../hooks/useCommonMediaQuery';

const DEFAULT_LINKS = [
  {
    id: 'greythr',
    title: 'GreytHR',
    subtitle: 'Payroll',
    mobileSubtitle: 'Payroll',
    href: 'https://youngsoftindia.greythr.com',
    accentColor: '#E0A84A',
  },
  {
    id: 'myswish',
    title: 'MySwish',
    subtitle: 'Insurance & Wellness',
    mobileSubtitle: 'Wellness',
    href: 'https://youngsoft.ethika.in/',
    accentColor: '#51A9A4',
  },
];

const QuickAccessLinkButton = ({ link }) => {
  const { title, subtitle, mobileSubtitle, href, accentColor } = link;
  const isMobile = useCommonMediaQuery('sm');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'end',
        backgroundColor: accentColor,
        borderRadius: 2,
        '&:hover': {
          backgroundColor: '#f9fafb',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        },
      }}
    >
      <Button
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1.25,
          minWidth: 0,
          textAlign: 'left',
          textTransform: 'none',
          backgroundColor: '#ffffff',
          color: '#1f2937',
          borderRadius: 2,
          border: 'none',
          width: '96%',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: '12px',
              lineHeight: 1.3,
              color: '#0F1729',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              fontSize: '10px',
              color: '#65758B',
              lineHeight: 1.3,
              width: {
                xs: '60px',
                sm: '100px',
                md: '100px',
              },
            }}
          >
            {isMobile ? mobileSubtitle : subtitle}
          </Typography>
        </Box>
        {!isMobile && (
          <OpenInNewIcon
            sx={{
              fontSize: 18,
              color: '#9ca3af',
              flexShrink: 0,
              '&:hover': {
                color: accentColor,
              },
            }}
          />
        )}
      </Button>
    </Box>
  );
};

const QuickAccessLinks = ({ links = DEFAULT_LINKS }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 6, sm: 16, md: 1.5, lg: 2, xl: 2 },
      }}
    >
      {links.map(link => (
        <QuickAccessLinkButton key={link.id} link={link} />
      ))}
    </Box>
  );
};

export default QuickAccessLinks;
export { QuickAccessLinkButton, DEFAULT_LINKS };
